import { render, staticRenderFns } from "./AppFullScreen.vue?vue&type=template&id=61be1acb&"
import script from "./AppFullScreen.vue?vue&type=script&lang=js&"
export * from "./AppFullScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61be1acb')) {
      api.createRecord('61be1acb', component.options)
    } else {
      api.reload('61be1acb', component.options)
    }
    module.hot.accept("./AppFullScreen.vue?vue&type=template&id=61be1acb&", function () {
      api.rerender('61be1acb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/widget/AppFullScreen.vue"
export default component.exports